// extracted by mini-css-extract-plugin
module.exports = {"image":"_6bf55ce5dc--image--f7kxD"};